// @flow

/**
 * Module dependencies.
 */

import { keyframes as keyframe } from 'styled-components';
import { units } from 'client/styles/units';

/**
 * Fade in animation.
 */

const fadeIn = keyframe`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

/**
 * Fade out animation.
 */

const fadeOut = keyframe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

/**
 * Spin animation.
 */

const spin = keyframe`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

/**
 * Shake animation.
 */

const shake = keyframe`
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(${units(1)}, 0, 0);
  }

  20%, 40%, 60%, 80% {
    transform: translate3d(${units(-1)}, 0, 0);
  }

  from, to {
    transform: translate3d(0, 0, 0);
  }
`;

/**
 * Export `keyframes`.
 */

export const keyframes = {
  fadeIn,
  fadeOut,
  shake,
  spin
};



// WEBPACK FOOTER //
// ../src/client/styles/keyframes.js